const ESTATUS_ACTIVO = "A";
const ESTATUS_ACTIVO_LABEL = "Activo";
const ESTATUS_INACTIVO = "I";
const ESTATUS_INACTIVO_LABEL = "Inactivo";

const METODO_PAGO_EFECTIVO_LABEL = "Efectivo";
const METODO_PAGO_CHEQUE_TRANSFERENCIA_DEPOSITO_LABEL = "Cheque/Transferencia/Depósito";
const METODO_PAGO_TARJETA_LABEL = "Tarjeta de Crédito/Tarjeta de Débito";
const METODO_PAGO_VENTA_CREDITO_LABEL = "Venta a Crédito";
const METODO_PAGO_BONO_CERTIFICADO_LABEL = "Bono/Certificado";
const METODO_PAGO_PERMUTA_LABEL = "Permuta";
const METODO_PAGO_NOTA_CREDITO_LABEL = "Nota de Crédito";
const METODO_PAGO_OTRO_LABEL = "Otras formas de pago";

export class MetodoPago {
  static get ESTATUS_LIST() {
    return [
      {
        value: ESTATUS_ACTIVO,
        label: ESTATUS_ACTIVO_LABEL,
      },
      {
        value: ESTATUS_INACTIVO,
        label: ESTATUS_INACTIVO_LABEL,
      },
    ];
  }

  static get METODO_PAGO_LIST() {
    return [
      { value: 1, label: METODO_PAGO_EFECTIVO_LABEL },
      { value: 2, label: METODO_PAGO_CHEQUE_TRANSFERENCIA_DEPOSITO_LABEL },
      { value: 3, label: METODO_PAGO_TARJETA_LABEL },
      { value: 4, label: METODO_PAGO_VENTA_CREDITO_LABEL },
      { value: 5, label: METODO_PAGO_BONO_CERTIFICADO_LABEL },
      { value: 6, label: METODO_PAGO_PERMUTA_LABEL },
      { value: 7, label: METODO_PAGO_NOTA_CREDITO_LABEL },
      { value: 8, label: METODO_PAGO_OTRO_LABEL },
    ];
  }

  static get DEFAULT_ESTATUS_VALUE() {
    return ESTATUS_ACTIVO;
  }

  static get PROPIEDADES_EXPORTAR() {
    const propiedades = [
      { value: "IdSec", label: "Id" },
      { value: "Nombre", label: "Nombre" },
      { value: "Indicador", label: "Indicador" },
      { value: "EstatusDesc", label: "Estatus" },
      { value: "CrearUsuario", label: "Crear Usuario" },
      { value: "FechaCreacion", label: "Fecha Creación" },
      { value: "ActualizarUsuario", label: "Actualizar Usuario" },
      { value: "FechaActualizacion", label: "Fecha Actualización" },
    ];
    return propiedades.sort((a, b) => (a.label > b.label ? 1 : -1));
  }
}
